/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ExportRequestMktuListInner
 */
export interface ExportRequestMktuListInner {
  /**
   * Номер класса МКТУ
   * @type {number}
   * @memberof ExportRequestMktuListInner
   */
  classNumber: number
  /**
   * Выбранные фразы класса
   * @type {Array<string>}
   * @memberof ExportRequestMktuListInner
   */
  selectedWords: Array<string>
}

/**
 * Check if a given object implements the ExportRequestMktuListInner interface.
 */
export function instanceOfExportRequestMktuListInner(
  value: object
): value is ExportRequestMktuListInner {
  if (!('classNumber' in value) || value['classNumber'] === undefined)
    return false
  if (!('selectedWords' in value) || value['selectedWords'] === undefined)
    return false
  return true
}

export function ExportRequestMktuListInnerFromJSON(
  json: any
): ExportRequestMktuListInner {
  return ExportRequestMktuListInnerFromJSONTyped(json, false)
}

export function ExportRequestMktuListInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExportRequestMktuListInner {
  if (json == null) {
    return json
  }
  return {
    classNumber: json['classNumber'],
    selectedWords: json['selectedWords'],
  }
}

export function ExportRequestMktuListInnerToJSON(
  value?: ExportRequestMktuListInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    classNumber: value['classNumber'],
    selectedWords: value['selectedWords'],
  }
}
